<div style="position: absolute;   z-index:100000; " class="app-tooltip" *ngIf="state" [style.top]="top+'px'"
   [style.left]="left+'px'">
   <div *ngIf="state.content">{{state.content}}</div>
   <div *ngFor="let c of state.contentList">{{c}}</div>
</div>